import ApiEndpoints from 'api/endpoints'
import { useMutate } from 'hooks'
import { ICustomerOrder } from 'models'

export const usePostPrepareSecurityDetails = (orderId: string) => {
  return useMutate<ICustomerOrder>(ApiEndpoints.postPrepareOrderSecDetails(orderId), {})
}
